import styled, { css, DefaultTheme } from 'styled-components';
import { Check } from '@styled-icons/remix-fill/Check';
import { transparentize } from 'polished';

type WrapperTypes = {
  selected: boolean;
};

const WrapperModifiers = {
  default: (theme: DefaultTheme) => css`
    border: 1px solid ${theme.colors.neutralGray20};
    background-color: ${transparentize(0.5, theme.colors.globalWhite100)};
  `,
  selected: (theme: DefaultTheme) => css`
    border: 1px solid ${theme.colors.statusSuccess20};
    background-color: ${theme.colors.globalWhite100};
  `,
};

export const Wrapper = styled.div<WrapperTypes>`
  ${({ theme, selected }) => css`
    border-radius: 16px;
    padding: 16px 24px;

    ${!selected && WrapperModifiers.default(theme)}
    ${selected && WrapperModifiers.selected(theme)}
  `}
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`;

export const PaymentIconWrapper = styled.div`
  ${({ theme }) => css`
    width: 40px;
    height: 40px;
    border: 1px solid ${theme.colors.neutralSilver10};
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;

    > svg {
      max-width: 24px;
      max-height: 24px;
    }
  `}
`;

export const CheckWrapper = styled.div`
  ${({ theme }) => css`
    width: 24px;
    height: 24px;
    background-color: ${theme.colors.statusSuccess20};
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  `}
`;

export const CheckIcon = styled(Check)`
  ${({ theme }) => css`
    width: 18px;
    height: 18px;
    color: ${theme.colors.globalWhite100};
  `}
`;

export const Title = styled.h3`
  ${({ theme }) => css`
    font-size: 1.6rem;
    font-weight: 600;
    color: ${theme.colors.neutralGray60};
    line-height: 1.6;
    margin: 0;
  `}
`;
